import { SVG } from '@svgdotjs/svg.js';

export function drawOnFloor(){
    const $block = $('#select_floor');
    const $drawingBlock = $block.find('[data-drawing-block]');

    if(!$drawingBlock.length) return;


    const $drawing = $block.find('[data-drawing]');
    const $popup = $('#popup')

    const items = $drawingBlock.data('items');


    $(window).on('load', function() {
        console.log($drawingBlock.outerHeight())
        console.log($drawingBlock[0].clientHeight)
    });
    const drawingOptions = {
        id: $drawing.attr('id'),
        image: $drawing.data('image'),
        colorBase: 'rgba(36, 59, 85, .2)',
        colorFill: 'rgba(36, 59, 85, 0.5)',
        width: 1100,
        height: 1000
    }

    init();

    function init(){
        drawingInit();
    }

    function drawingInit() {
        const draw = SVG().addTo(`#${drawingOptions.id}`);
        draw.viewbox(0, 0, drawingOptions.width, drawingOptions.height);

        const image = draw.image(drawingOptions.image);
// Устанавливаем размеры картинки
        image.size("100%", "100%").move(0, 0);


// Устанавливаем координаты картинки
        console.log(items)

        items.forEach(data => {
            addPolygonItem(draw, data);
        })
    }

    function addPolygonItem(draw, item) {
        const polygon = draw.polygon(item.coords).fill(drawingOptions.colorBase).data({
            id: item.id,
            count: item.count,
            area: item.area,
            coords: item.coords,
            link: item.link
        }).css('cursor', 'pointer');

        const group = draw.group().add(polygon);

        const centerX = polygon.cx();
        const centerY = polygon.cy();

        const circle = draw.circle(40).fill('#fff');
        let text;
        if(item.count == 0){
             text = draw.text(`С`).font({family: 'HelveticaNeueCyr', size: 14}).fill('#243B55');
        } else {
             text = draw.text(`${item.count}`).font({family: 'HelveticaNeueCyr', size: 14}).fill('#243B55');
        }

        const textBBox = text.bbox();
        const circleBBox = circle.bbox();

        circle.move(centerX - circleBBox.width / 2, centerY - circleBBox.height / 2);
        text.move(centerX - textBBox.width / 2, centerY - textBBox.height / 2);

        group.add(circle, text);

        // Добавляем элемент <tspan> со знаком "+" вместо числа
        const plusText = draw.text('+').font({family: 'HelveticaNeueCyr', size: 32}).fill('#243B55').attr({display: 'none'});
        const plusTextBBox = plusText.bbox();
        plusText.move(centerX - plusTextBBox.width / 2-9.5, centerY - plusTextBBox.height / 2+9);
        plusText.style("transform", "translate(-50%, -50%)");
        group.add(plusText);

        initPolyEventsHandler(polygon, text, plusText);
    }

    function initPolyEventsHandler(item, text, plusText){
        if(isDesktop()) {
            item.mouseover(function () {
                this.fill(drawingOptions.colorFill);
                // Скрываем текст с числом и показываем элемент со знаком "+"
                text.attr({display: 'none'});
                plusText.attr({display: 'block'});
                setModalContent(item);
                openModal(item);
            })
                .mouseout(function () {
                    this.fill(drawingOptions.colorBase)
                    // Скрываем элемент с знаком "+" и показываем текст с числом
                    plusText.attr({display: 'none'});
                    text.attr({display: 'block'});
                    closeModal();
                })
                .click(function (){
                    window.location.href = item.data('link');
                })
        } else {
            item.click(function () {
                window.location.href = item.data('link');
            })
        }
    }

    function setModalContent(item){

        let result = ``;

        const data = item.data();

        if(data.count == 0){
            $popup.find('.popup-wrapper').append(
                `
        <div class="count">Студия</div>
         <div class="area">${data.area} м<sup>2</sup></div>
            `
            );
        }
        else if(data.count == 1){
            $popup.find('.popup-wrapper').append(
                `
        <div class="count">${data.count} комната</div>
         <div class="area">${data.area} м<sup>2</sup></div>
            `
            );
        }
        else {

            $popup.find('.popup-wrapper').append(
                `
        <div class="count">${data.count} комнаты </div>
         <div class="area">${data.area} м<sup>2</sup></div>
            `
            );
        }

    }

    function openModal(item){
        if(isDesktop()){
            const data = item.node.getBoundingClientRect();
            const widthOffset = $(window).scrollTop();

            $popup.css({
                left: data.right - (data.right - data.left)/2 + 30,
                top: data.bottom - (data.bottom - data.top)/2 + widthOffset - 40
            }).removeClass('hide');
        }

    }

    function closeModal(){
        $popup.addClass('hide').find('.popup-wrapper').empty();
    }

    function isDesktop(){
        return (window.innerWidth > 1000);
    }

}
